/**************************************************
 * Nombre:       Seccion_Cupones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_FALS_VERDADERO,
    CASILLA_FECHA_DATO,
    CASILLA_TEXTO,
    CASILLA_TITULO_DATO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import React from "react";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import {ManageSearch} from "@mui/icons-material";
import Dialogo_Suscriptores from "../Dialogos/Dialogo_Suscriptores";
import Dialogo_Cupones from "../Dialogos/Dialogo_Cupones";


const Seccion_Cupones = () => {
    const {
        props,
        setData,
        setNumeroFilas,
        cargarNuevamente
    } = useObtenerColleccionTabla2025({coleccion: 'cupones'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Cupones,
        titulo: 'Detalles del cupon',
        realizado: cargarNuevamente
    })

    const click = (id, data) => {

        switch (id) {
            case 'detalles':
                abrir(data)
            default :
                abrir(data)
        }
    }


    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Dialogo/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Lista de cupones'}
                        descripcion={`${props.numeroFilas} en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //  botones={[]}
                    />
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Seccion_Cupones

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    },
]

const datosCabecera = [
    {
        nombre: 'Codigo',
        direccion: 'left',
        propiedad: 'codigo',
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATO
    },
    {
        nombre: 'nombre',
        direccion: 'left',
        propiedad: 'nombre',
        titulo: 'correo',
        tipo: CASILLA_TITULO_DATO

    },
    {
        nombre: 'porcentaje',
        direccion: 'left',
        propiedad: 'porcentaje',
        tipo: CASILLA_TEXTO

    },
    {
        nombre: 'cangeado',
        direccion: 'right',
        propiedad: 'cangeado',
        tipo: CASILLA_FALS_VERDADERO,
    },

]

const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    }
]